<template>
  <nav class="nav-items">
    <ul class="nav-items__list">
      <li class="nav-items__list-item">
        <router-link to="/projects">Портфолио</router-link>
      </li>
      <li class="nav-items__list-item" @click="scrollToBlock('contacts')">
        Контакты
      </li>
      <li
        v-if="showFaq"
        class="nav-items__list-item"
        @click="scrollToBlock('faq')"
      >
        Частые вопросы
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import useScrollToBlock from '@/features/useScrollToBlock'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'NavItems',
  setup() {
    const showFaq = computed(() => {
      const route = useRoute()

      return route.name === 'Index'
    })

    return { showFaq, ...useScrollToBlock() }
  },
})
</script>

<style lang="scss" scoped src="./index.scss" />
